














import Vue from 'vue'
import { Route } from 'vue-router'
import Logo from '@/components/globals/logo.vue'
import Drawer from '@/components/mobile-drawer.vue'
// import TsWrapper from '@/utils/typesquare'
// const Ts = new TsWrapper()

export default Vue.extend({
  components: { Drawer, Logo },
  data() {
    return {
      transitionName: ''
    }
  },
  // methods: {
  //   beforeEnter() {
  //     Ts.loadFont()
  //   }
  // },
  computed: {
    isTop(): boolean { 
      return this.$route.name === 'home' ? true : false
    }
  }
  // watch: {
  //   $route(to: Route, from: Route) {
  //     this.transitionName = from.meta.pid < to.meta.pid ? 'slide-next' : 'slide-prev'
  //   }
  // }
})
